import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../../components/textbox/Input";
import CheckBox from "../../../../../../../components/checkbox/CheckBox";
import Calendar from "../../../../../../../components/calendar/Calendar";
import styles from "../../../../InfoCliniche/InfoCliniche.module.css";
import Utils from "../../../../../../../utils/Utils";
import Autocomplete from "../../../../../../../components/autocomplete/Autocomplete";

class InformazioniCliniche extends Component {

    state = {
        informazioniCliniche: {
            presenzaSintomi: "",
            dataSintomi: "",
            febbre: "",
            manifestazioniCliniche: [],
            altriSintomiNeurologici: "",
            altriSintomiNonNeurologici: "",
            condizioniRischioPreesistenti: "",
            condizioniRischioSpecificare: "",
            ricoveroOspedaliero: "",
            dataRicovero: "",
            ospedale: "",
            corretto: []
        },
        struttureAndStabilimentiPerCodice: JSON.parse(
            sessionStorage.getItem("struttureAndStabilimentiPerCodice")
        ),
        struttureAndStabilimenti: JSON.parse(
            sessionStorage.getItem("struttureAndStabilimenti")
        )
    };

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.aggiornaPadre = this.aggiornaPadre.bind(this);
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia?.schedaSpeciale?.informazioniCliniche) {
            let datiRecuperati = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.informazioniCliniche));
            if (!Array.isArray(datiRecuperati.manifestazioniCliniche)) {
                datiRecuperati.manifestazioniCliniche = [];
            }
            datiRecuperati.ospedale = this.props.segnalazioneCopia.schedaSpeciale
                .informazioniCliniche.ospedale || "";
            this.setState(
                { informazioniCliniche: { ...this.state.informazioniCliniche, ...datiRecuperati } },
                () => this.aggiornaPadre()
            );
        } else if (this.props.segnalazioneCopia.datiSanitari) {
            const infoCli = this.props.segnalazioneCopia.infoCliniche;
            const lista = (infoCli && Array.isArray(infoCli.listaDettaglioCli)) ? infoCli.listaDettaglioCli : [];

            const hasFebbre = lista.some(d => d.dettaglio === "75");

            const codiciManifestazioni = [
                { dettaglio: "62",  key: "encefalite" },
                { dettaglio: "102", key: "encefalite" },
                { dettaglio: "245", key: "encefalite" },
                { dettaglio: "261", key: "encefalite" },
                { dettaglio: "232", key: "poliradicoloneurite" },
                { dettaglio: "244", key: "poliradicoloneurite" },
                { dettaglio: "21",  key: "astenia" },
                { dettaglio: "220", key: "astenia" },
                { dettaglio: "10",  key: "artralgia" },
                { dettaglio: "194", key: "artralgia" },
                { dettaglio: "104", key: "mialgia" },
                { dettaglio: "192", key: "rush" },
                { dettaglio: "233", key: "rush" },
                { dettaglio: "239", key: "rush" },
                { dettaglio: "161", key: "nausea" },
                { dettaglio: "193", key: "nausea" },
                { dettaglio: "230", key: "dolore_orbitale" },
                { dettaglio: "262", key: "congiuntivite" },
                { dettaglio: "263", key: "congiuntivite" },
                { dettaglio: "231", key: "paralisi" },
                { dettaglio: "101", key: "meningite" },
                { dettaglio: "254", key: "meningite" },
                { dettaglio: "102", key: "meningite" },
                { dettaglio: "100", key: "emorragica" },
                { dettaglio: "195", key: "emorragica" },
                { dettaglio: "259", key: "emorragica" },
            ];
            const { t } = this.props;
            const path = "SchedaSpecialeArbovirosi.InformazioniCliniche";
            const manifestazioni = codiciManifestazioni
                .filter(({ dettaglio }) => lista.some(d => d.dettaglio === dettaglio))
                .map(({ key }) => t(`${path}.opzioniManifestazione.${key}`));

            this.setState(prev => ({
                    informazioniCliniche: {
                        ...prev.informazioniCliniche,
                        presenzaSintomi: (this.props.segnalazioneCopia.datiSanitari.dataInizioSintomi || infoCli?.informazioniCliniche === "1") ? "01" : "",
                        dataSintomi: this.props.segnalazioneCopia.datiSanitari.dataInizioSintomi? Utils.formatDateISO(this.props.segnalazioneCopia.datiSanitari.dataInizioSintomi, "/") : "",
                        febbre: hasFebbre ? "01" : "",
                        manifestazioniCliniche: manifestazioni,
                        ricoveroOspedaliero: this.props.segnalazioneCopia.datiSanitari.ricovero === "1"? "01" : "",
                        dataRicovero: this.props.segnalazioneCopia.datiSanitari.dataRicovero? Utils.formatDateISO(this.props.segnalazioneCopia.datiSanitari.dataRicovero, "/") : "",
                        ospedale: this.props.segnalazioneCopia.datiSanitari.struttura? this.state.struttureAndStabilimentiPerCodice[this.props.segnalazioneCopia.datiSanitari.struttura] :
                            this.props.segnalazioneCopia.datiSanitari.strutturaExtra? this.state.struttureAndStabilimentiPerCodice[this.props.segnalazioneCopia.datiSanitari.strutturaExtra] : "",
                        corretto: []
                    }
                    }),() => this.aggiornaPadre()
            );
        } else {
            this.aggiornaPadre();
        }
    }

    riceviValore(field, event) {
        let valore = (event && event.target) ? event.target.value : event;

        this.setState(prevState => {
            let nuovaInfo = { ...prevState.informazioniCliniche };
            nuovaInfo[field] = valore;

            // Reset logici
            if (field === "presenzaSintomi" && valore !== "01") {
                nuovaInfo.dataSintomi = "";
                nuovaInfo.febbre = "";
                nuovaInfo.manifestazioniCliniche = [];
                nuovaInfo.altriSintomiNeurologici = "";
                nuovaInfo.altriSintomiNonNeurologici = "";
                nuovaInfo.condizioniRischioPreesistenti = "";
                nuovaInfo.condizioniRischioSpecificare = "";
                nuovaInfo.ricoveroOspedaliero = "";
                nuovaInfo.dataRicovero = "";
                nuovaInfo.ospedale = "";
            }
            if (field === "ricoveroOspedaliero" && valore !== "01") {
                nuovaInfo.dataRicovero = "";
                nuovaInfo.ospedale = "";
            }
            if (field === "condizioniRischioPreesistenti" && valore !== "01") {
                nuovaInfo.condizioniRischioSpecificare = "";
            }

            return { informazioniCliniche: nuovaInfo };
        }, () => this.aggiornaPadre());
    }

    toggleCheckbox(labelValue, inputField) {
        this.setState(prevState => {
            let nuovaInfo = { ...prevState.informazioniCliniche };
            let list = Array.isArray(nuovaInfo.manifestazioniCliniche)
                ? [...nuovaInfo.manifestazioniCliniche]
                : [];

            if (list.includes(labelValue)) {
                list = list.filter(item => item !== labelValue);
                if (inputField) nuovaInfo[inputField] = "";
            } else {
                list.push(labelValue);
            }

            nuovaInfo.manifestazioniCliniche = list;
            return { informazioniCliniche: nuovaInfo };
        }, () => this.aggiornaPadre());
    }

    // ── Controllo campi obbligatori ──
    controlloCorrettezza() {
        let dati = this.state.informazioniCliniche;
        dati.corretto = [];

        if (!dati.presenzaSintomi) {
            dati.corretto[0] = "Campo Presenza Sintomi obbligatorio";
        }

        if (dati.presenzaSintomi === "01") {
            if (!dati.dataSintomi) {
                dati.corretto[1] = "Campo Data Inizio Sintomi obbligatorio";
            }
            if (!dati.febbre) {
                dati.corretto[2] = "Campo Febbre obbligatorio";
            }
        }
    }

    // ── Costruzione oggetto per il backend ──
    createOggettoBE() {
        let copiaDati = JSON.parse(JSON.stringify(this.state.informazioniCliniche));

        // Gestione esplicita dell'array manifestazioniCliniche
        if (!copiaDati.manifestazioniCliniche || copiaDati.manifestazioniCliniche.length === 0) {
            delete copiaDati.manifestazioniCliniche;
        }

        let pulito = Utils.removeEmptyValueFromObject(copiaDati);
        return Utils.removeFieldFromObject(pulito, "corretto");
    }

    // ── Aggiorna il padre con (dati, validateStr, oggettoBE) ──
    aggiornaPadre() {
        this.controlloCorrettezza();

        if (this.props.controlloCorrettezza) {
            this.props.controlloCorrettezza();
        }

        const dati = this.state.informazioniCliniche;

        const oggettoBE = this.createOggettoBE();

        if (this.props.setInformazioniCliniche) {
            // Ordine atteso dal padre: (dati, validateStr, datiBe)
            this.props.setInformazioniCliniche(dati, oggettoBE);
        }
    }

    render() {
        const { t } = this.props;
        const { informazioniCliniche: data } = this.state;
        const path = "SchedaSpecialeArbovirosi.InformazioniCliniche";

        const labelSi      = t("SchedaSpecialeTubercolosi.si");
        const labelNo      = t("SchedaSpecialeTubercolosi.no");
        const labelNonNoto = t("SchedaSpecialeTubercolosi.nonNoto");

        // Flag derivati
        const sintomiSi = data.presenzaSintomi === "01";

        const opzioni = [
            { k: "encefalite" },
            { k: "meningite" },
            { k: "poliradicoloneurite" },
            { k: "paralisi" },
            { k: "altri_neurologici",     input: "altriSintomiNeurologici" },
            { k: "astenia" },
            { k: "artralgia" },
            { k: "poliartralgia" },
            { k: "mialgia" },
            { k: "rush" },
            { k: "nausea" },
            { k: "dolore_orbitale" },
            { k: "congiuntivite" },
            { k: "emorragica" },
            { k: "altri_non_neurologici", input: "altriSintomiNonNeurologici" }
        ];

        let resFiltraStrutture =
            this.props.segnalazioneCopia.ulssSegnalazione &&
            this.state.struttureAndStabilimenti
                ? Utils.filtraStruttureAndStabilimenti(
                    this.props.segnalazioneCopia.ulssSegnalazione,
                    this.state.struttureAndStabilimenti
                )
                : null;
        const filtrati = resFiltraStrutture?.struttureAndStabilimentiFiltrati ?? [];
        const restanti = resFiltraStrutture?.struttureAndStabilimentiRestanti ?? [];

        let suggestionsUniche = [...filtrati, ...restanti];

        suggestionsUniche = Array.from(
            new Map(suggestionsUniche.map(item => [item.codice, item])).values()
        )

        return (

            <div className={"container-fluid"} style={{ fontSize: "14px" }}>

                <div className={"container"}>
                    <div style={{marginTop: "10px"}}/>
                    <div className="row mt-2">
                        <div className="col-lg-4">
                            <p
                                style={{
                                    fontWeight: "bold",
                                    fontSize: "15px",
                                    color: "black"
                                }}
                            >
                                {t(`${path}.presenzaSintomi`)}
                                <span className={styles.mandatoryColor}> *</span>
                            </p>
                            <div className="d-flex">
                                <RadioButton
                                    id="ps_si" label={labelSi} value="01"
                                    onClick={() => this.riceviValore("presenzaSintomi", "01")}
                                    checked={data.presenzaSintomi === "01"}
                                    newRadio={true}
                                />
                                <div style={{ marginLeft: "15px" }}>
                                    <RadioButton
                                        id="ps_no" label={labelNo} value="02"
                                        onClick={() => this.riceviValore("presenzaSintomi", "02")}
                                        checked={data.presenzaSintomi === "02"}
                                        newRadio={true}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* ── DATA INIZIO SINTOMI ── */}
                        <div className="col-lg-4">
                            <p style={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "#1b7ea9"
                                }}
                            >
                                {t(`${path}.dataInizioSintomi`)}
                                {sintomiSi && <span className={styles.mandatoryColor}> *</span>}
                            </p>
                            <Calendar
                                id="dataSintomi"
                                value={data.dataSintomi}
                                onChange={(v) => this.riceviValore("dataSintomi", v)}
                                disabled={!sintomiSi}
                            />
                        </div>
                    </div>

                    {/* ── FEBBRE ── */}
                    <div className="row mt-2 align-items-center">
                        <div className="col-lg-4">
                            <p
                                style={{
                                    fontWeight: "bold",
                                    fontSize: "15px",
                                    color: "black"
                                }}
                            >
                                {t(`${path}.febbre`)}
                                {sintomiSi && <span className={styles.mandatoryColor}> *</span>}
                            </p>
                        </div>
                        <div className="col-lg-8 d-flex">
                            <RadioButton
                                id="f_si" label={labelSi} value="01"
                                onClick={() => this.riceviValore("febbre", "01")}
                                checked={data.febbre === "01"}
                                newRadio={true}
                                disabled={!sintomiSi}
                            />
                            <div style={{ marginLeft: "30px" }}>
                                <RadioButton
                                    id="f_no" label={labelNo} value="02"
                                    onClick={() => this.riceviValore("febbre", "02")}
                                    checked={data.febbre === "02"}
                                    newRadio={true}
                                    disabled={!sintomiSi}
                                />
                            </div>
                            <div style={{ marginLeft: "30px" }}>
                                <RadioButton
                                    id="f_nn" label={labelNonNoto} value="03"
                                    onClick={() => this.riceviValore("febbre", "03")}
                                    checked={data.febbre === "03"}
                                    newRadio={true}
                                    disabled={!sintomiSi}
                                />
                            </div>
                        </div>
                    </div>

                    {/* ── MANIFESTAZIONI CLINICHE ── */}
                    <div className="row mt-2" >
                        <div className="col-lg-4">
                            <p
                                style={{
                                    fontWeight: "bold",
                                    fontSize: "15px",
                                    color: "black"
                                }}
                            >
                                {t(`${path}.manifestazioneClinica`)}</p>
                        </div>
                        <div className="col-lg-8">
                            {opzioni.map(item => {
                                const lbl       = t(`${path}.opzioniManifestazione.${item.k}`);
                                const isChecked = data.manifestazioniCliniche.includes(lbl);

                                return (
                                    <div className="row" key={item.k}>
                                        <div className="col-lg-7">
                                            <CheckBox
                                                id={`ck_${item.k}`}
                                                text={lbl}
                                                checked={isChecked}
                                                onChange={() => this.toggleCheckbox(lbl, item.input)}
                                                newCheckbox={true}
                                                disabledFlag={!sintomiSi}
                                            />
                                        </div>
                                        {item.input && (
                                            <div className="col-lg-5">
                                                <Input
                                                    field={item.input}
                                                    value={data[item.input] || ""}
                                                    onChange={this.riceviValore}
                                                    placeholder={t("specificare")}
                                                    disabled={!isChecked}
                                                />
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* ── CONDIZIONI RISCHIO PREESISTENTI ── */}
                    <div className="row mt-4 align-items-center">
                        <div className="col-lg-4">
                            <p
                                style={{
                                    fontWeight: "bold",
                                    fontSize: "15px",
                                    color: "black"
                                }}
                            >
                                {t(`${path}.condizioniRischio`)}</p>
                        </div>
                        <div className="col-lg-4 d-flex">
                            <RadioButton
                                id="cr_si" label={labelSi} value="01"
                                onClick={() => this.riceviValore("condizioniRischioPreesistenti", "01")}
                                checked={data.condizioniRischioPreesistenti === "01"}
                                newRadio={true}
                                disabled={!sintomiSi}
                            />
                            <div style={{ marginLeft: "15px" }}>
                                <RadioButton
                                    id="cr_no" label={labelNo} value="02"
                                    onClick={() => this.riceviValore("condizioniRischioPreesistenti", "02")}
                                    checked={data.condizioniRischioPreesistenti === "02"}
                                    newRadio={true}
                                    disabled={!sintomiSi}
                                />
                            </div>
                            <div style={{ marginLeft: "15px" }}>
                                <RadioButton
                                    id="cr_nn" label={labelNonNoto} value="03"
                                    onClick={() => this.riceviValore("condizioniRischioPreesistenti", "03")}
                                    checked={data.condizioniRischioPreesistenti === "03"}
                                    newRadio={true}
                                    disabled={!sintomiSi}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <Input
                                field="condizioniRischioSpecificare"
                                value={data.condizioniRischioSpecificare || ""}
                                onChange={this.riceviValore}
                                placeholder={t("specificare")}
                                disabled={data.condizioniRischioPreesistenti !== "01"}
                            />
                        </div>
                    </div>

                    {/* ── RICOVERO OSPEDALIERO ── */}
                    <div className="row mt-4 align-items-center">
                        <div className="col-lg-4">
                            <p
                                style={{
                                    fontWeight: "bold",
                                    fontSize: "15px",
                                    color: "black"
                                }}
                            >
                                {t(`${path}.ricovero`)}</p>
                        </div>
                        <div className="col-lg-8 d-flex">
                            <RadioButton
                                id="ro_si" label={labelSi} value="01"
                                onClick={() => this.riceviValore("ricoveroOspedaliero", "01")}
                                checked={data.ricoveroOspedaliero === "01"}
                                newRadio={true}
                                disabled={!sintomiSi}
                            />
                            <div style={{ marginLeft: "30px" }}>
                                <RadioButton
                                    id="ro_no" label={labelNo} value="02"
                                    onClick={() => this.riceviValore("ricoveroOspedaliero", "02")}
                                    checked={data.ricoveroOspedaliero === "02"}
                                    newRadio={true}
                                    disabled={!sintomiSi}
                                />
                            </div>
                            <div style={{ marginLeft: "30px" }}>
                                <RadioButton
                                    id="ro_nn" label={labelNonNoto} value="03"
                                    onClick={() => this.riceviValore("ricoveroOspedaliero", "03")}
                                    checked={data.ricoveroOspedaliero === "03"}
                                    newRadio={true}
                                    disabled={!sintomiSi}
                                />
                            </div>
                        </div>
                    </div>

                    {/* ── DATA RICOVERO + OSPEDALE ── */}
                    <div className="row mt-4 mb-5">
                        <div className="col-lg-4">
                            <p
                                style={{
                                    fontWeight: "bold",
                                    fontSize: "15px",
                                    color: "#1b7ea9"
                                }}
                            >
                                {t(`${path}.dataRicovero`)}
                            </p>
                            <Calendar
                                id="dataRicovero"
                                value={data.dataRicovero}
                                onChange={(v) => this.riceviValore("dataRicovero", v)}
                                disabled={data.ricoveroOspedaliero !== "01"}
                            />
                        </div>
                        <div className="col-lg-4">
                            <p style={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "#1b7ea9"
                                }}
                            >
                                {t(`${path}.ospedale`)}
                            </p>
                            <Autocomplete
                                id={"ospedale"}
                                value={data.ospedale}
                                keyField={"codice"}
                                descriptionField={"descrizione"}
                                suggestionField={"descrizione"}
                                onChange={this.riceviValore}
                                field={"ospedale"}
                                placeholder={t(`${path}.ospedale`)}
                                disabled={data.ricoveroOspedaliero !== "01"}
                                suggestions={suggestionsUniche}
                            ></Autocomplete>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default withTranslation('common')(InformazioniCliniche);